export default "__VITE_ASSET__zXBfxrBD__"